import { useState } from "react";
import { MessageCircle, PlayCircle, Video } from "lucide-react";
import { CopyBlock } from "./AdsKit";

export function PersonalDemo({ site }) {
  const [school, setSchool] = useState(""); const [city, setCity] = useState("");
  const q = new URLSearchParams({ ...(school.trim() && { school: school.trim() }), ...(city.trim() && { city: city.trim() }) }).toString();
  const link = `${site}/live-demo${q ? `?${q}` : ""}`;
  const recLink = `${site}/live-demo?${q ? `${q}&` : ""}record=1`;
  const msg = `Namaste! ${school.trim() ? `${school.trim()} ke liye ` : ""}FeeMitra ka live demo dekhein — online fee, WhatsApp reminder aur turant receipt:\n${link}`;
  return <section className="section-block" data-testid="personal-demo">
    <div className="section-title"><div><h2><PlayCircle size={15} /> School ke naam wala Live Demo</h2><p className="muted">School ka naam aur shahar likhein — demo mein wahi naam dikhega.</p></div></div>
    <div className="rk-fields">
      <label>School ka naam<input value={school} maxLength={50} onChange={e => setSchool(e.target.value)} placeholder="e.g. Saraswati Vidya Mandir" data-testid="pd-school-input" /></label>
      <label>Shahar<input value={city} maxLength={30} onChange={e => setCity(e.target.value)} placeholder="e.g. Jaipur" data-testid="pd-city-input" /></label>
    </div>
    <div className="adk-texts">
      <CopyBlock t={{ id: "pd-link", title: "School ko bhejne ka link", body: link }} />
      <CopyBlock t={{ id: "pd-rec", title: "Recording link (khud screen record karein)", body: recLink }} />
    </div>
    <div className="pd-actions">
      <a className="primary-btn" href={`https://wa.me/?text=${encodeURIComponent(msg)}`} target="_blank" rel="noreferrer" data-testid="pd-whatsapp-btn"><MessageCircle size={15} /> WhatsApp par bhejein</a>
      <a className="secondary-btn" href={link} target="_blank" rel="noreferrer" data-testid="pd-open-btn"><PlayCircle size={15} /> Demo kholein</a>
      <a className="secondary-btn" href={recLink} target="_blank" rel="noreferrer" data-testid="pd-record-btn"><Video size={15} /> Recording mode kholein</a>
    </div>
  </section>;
}
